import axios from "axios";
import { LOGIN_SETTINGS_API } from "../../../constants/api";

export default function GetLoginSetting(){
    const api = `${LOGIN_SETTINGS_API}o/`;
    return axios.get(api);
}